import {fetchMetaDataApi, exportToExcelFileOverviewDetailsApi, downloadCashRegisterApi,fetchRemarksOptionsApi } from '../../services/common-api';
import {fetchOverviewApi,fetchOverviewDetailsApi, updateOverviewRevenueDetailsApi, uploadCashRegisterApi} from '../../services/nmbs-users-api';

export const fetchMetaData = () => {
    return fetchMetaDataApi(2);
}

export const fetchOverview = () => {
    return fetchOverviewApi();
}

export const fetchOverviewDetails = (showDetailRequestModel) => {
    return fetchOverviewDetailsApi(showDetailRequestModel);
}

export const updateOverviewRevenueDetails = (updateDetailRequestModel) => {
    return updateOverviewRevenueDetailsApi(updateDetailRequestModel);
}

export const exportToExcelOverviewDetails = (overviewDetailRequestModel) => {
    return exportToExcelFileOverviewDetailsApi(overviewDetailRequestModel);
}

export const downloadCashRegister = (contractCode, revenueDate) => {
    return downloadCashRegisterApi(contractCode, revenueDate, null );
}

export const uploadCashRegister = (requestFormData) => {
    return uploadCashRegisterApi(requestFormData);
}

export const fetchRemarksOptions = () => {
    return fetchRemarksOptionsApi();
}
